import { render, staticRenderFns } from "./customCheckbox.vue?vue&type=template&id=52cb4742"
import script from "./customCheckbox.vue?vue&type=script&lang=js"
export * from "./customCheckbox.vue?vue&type=script&lang=js"
import style0 from "./customCheckbox.vue?vue&type=style&index=0&id=52cb4742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports